import React from "react";
import { FileText, Download, FileCode, FileType } from "lucide-react";

interface NewsletterFinalOutputProps {
  response: any;
}

const getFileIcon = (link: string) => {
  if (!link) {
    return <FileText className="w-2 h-2 text-gray-400" />;
  }

  const lowerLink = link.toLowerCase();

  if (lowerLink.includes(".html") || lowerLink.includes("html")) {
    return <FileCode className="w-2 h-2 text-blue-600" />;
  } else if (lowerLink.includes(".pdf") || lowerLink.includes("pdf")) {
    return <FileType className="w-2 h-2 text-red-600" />;
  } else {
    return <FileText className="w-2 h-2 text-blue-600" />;
  }
};

const NewsletterFinalOutput: React.FC<NewsletterFinalOutputProps> = ({ response }) => {
  if (
    !response ||
    !response.final_output ||
    !Array.isArray(response.final_output) ||
    response.final_output.length === 0
  ) {
    return <div className="p-4 text-sm text-gray-600">No final output available.</div>;
  }

  const finalOutputData = response.final_output;

  return (
    <div className="h-[90vh] max-w-xl border rounded-xl border-gray-300 overflow-y-auto pn_scroller p-3">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Export Package</h2>

      <div className="space-y-2">
        {finalOutputData.map((item: any, idx: number) => (
          <a
            key={idx}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between p-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors group"
          >
            <div className="flex items-center gap-3">
              <div className=" rounded">{getFileIcon(item.link)}</div>
              <span className="text-gray-700 font-medium text-sm">{item.title}</span>
            </div>
            <div className="p-2  rounded-full group-hover:bg-gray-100 transition-colors">
              <Download className="w-2 h-2 text-black" />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default NewsletterFinalOutput;
